import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setCidade } from '../../api/apiFactory';
import {
  fetchLimparCookie, fetchNomeCidade, fetchSicFrequentes,
} from '../../api/endpoints';
import { definirCidade, fetchConfiguracoesCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao } from '../../app/slices/loginSlice';
import { abrirModalAjuda, resetarModais, selectModal } from '../../app/slices/modalSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import ListaSic from '../../components/ListaSic/ListaSic';
import ModalAjuda from '../../components/ModalAjuda/ModalAjuda';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import VisualizadorArquivos from '../../components/VisualizadorArquivos/VisualizadorArquivos';
import {
  AppBody, AppFragment, Container, Interno, Titulo,
} from '../../styles/base';

const IniciarSicFrequentes = () => {
  const dispatch = useDispatch();
  const dadosModal = useSelector(selectModal);
  const [listaFrequentes, setListaFrequentes] = useState(null);
  const history = useHistory();

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  useEffect(() => {
    if (cookieId) {
      const escolherCidadeCookie = async (Id, Campo) => {
        setCidade({ Id, Campo });
        dispatch(definirCidade({
          idCidade: Id,
          nomeCidade: Campo,
        }));
        await fetchLimparCookie();
        await dispatch(fetchConfiguracoesCidade());
      };

      dispatch(desfazerConexao());
      fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
    }

    fetchSicFrequentes().then(setListaFrequentes);
  }, [cookieId]);

  if (!listaFrequentes) {
    return (
      <Carregar />
    );
  }

  if (listaFrequentes.Message) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        <AppHeader />
        <Botao
          onClick={() => history.push('/sic')}
          sicFrequentes
        />
        <Botao
          onClick={() => dispatch(abrirModalAjuda())}
          ajuda
        />
        <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
          <Container>
            <Titulo style={{ marginBottom: 10 }}>SIC - Perguntas Frequentes</Titulo>

            <Interno>
              <p>Nenhuma pergunta cadastrada.</p>
            </Interno>
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      {dadosModal.modalAjuda === 'aberto' && (<ModalAjuda sic />)}
      <AppHeader />
      <Botao
        onClick={() => history.push('/sic')}
        sicFrequentes
      />
      <Botao
        onClick={() => dispatch(abrirModalAjuda())}
        ajuda
      />
      <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
        <Container>
          <Titulo style={{ marginBottom: 10 }}>SIC - Perguntas Frequentes</Titulo>

          <Interno>
            {listaFrequentes.length && listaFrequentes.map((sic) => (
              <ListaSic
                frequentes
                key={sic.Id}
                pergunta={sic.Pergunta}
                resposta={sic.Resposta}
                dataHora={sic.DataHora}
                secretaria={sic.Secretaria}
              />
            ))}
          </Interno>
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarSicFrequentes;
